<template>
  <div class="h-100" :id="'popover-target-' + event.id">
    {{ event.startRaw | adjustToTimezone("HH:mm") }}

    <span v-if="event.paid" class="fa-stack fa-sm-custom">
      <i class="fa fa-money-bill-wave fa-stack-1x"></i>
    </span>
    <span v-else class="fa-stack fa-sm-custom">
      <i class="fa fa-money-bill-wave fa-stack-1x"></i>
      <i class="fa fa-ban fa-stack-2x text-danger"></i>
    </span>

    <span v-if="event.online" class="fa-stack fa-sm-custom">
      <i class="fas fa-video fa-stack-1x"></i>
    </span>
    <span v-else class="fa-stack fa-sm-custom">
      <i class="fas fa-video fa-stack-1x"></i>
      <i class="fa fa-ban fa-stack-2x text-danger"></i>
    </span>
    <span v-if="event.invoice" class="mr-2 badge badge-pill badge-success">F</span>
    <span v-if="typeSchedule == 'PROFESSIONAL' && event.name">{{ event.name }}</span>
    <span v-else>{{ event.professional.name }}</span>

    <b-popover :target="'popover-target-' + event.id" triggers="hover" placement="top" class="mobile-hide d-none">
      <template #title><b> {{ event.startRaw | adjustToTimezone("DD/MM/YYYY") }}</b></template>

      <div class="user-details-block">
        <div>
          <b>
            {{ event.startRaw | adjustToTimezone("HH:mm") }} -
            {{ event.endRaw | adjustToTimezone("HH:mm") }}
          </b>
        </div>
        <hr />
        <div v-if="typeSchedule == 'PROFESSIONAL' && event.name" class="text-center mt-3">
          {{ event.name }}
        </div>
        <div v-else class="text-center mt-3">
          {{ event.professional.name }}
        </div>
        <hr />
        <div v-if="event.minutes">
          <span>{{ event.minutes }} Min. </span><span> Online </span>
        </div>
        <div>
          <span v-if="event.paid" class="badge badge-success">{{ $t("generic.paid") }}</span>
          <span v-else class="badge badge-danger">{{ $t("generic.nopaid") }}</span>
        </div>
        <hr />
        <div v-if="event.visitType">
          <i :style="'color: ' + event.visitType.colour" class="fas fa-circle mr-2"></i>{{ event.visitType.name }}
        </div>
      </div>

    </b-popover>
  </div>
</template>

<script>
import IqCard from "../../components/xray/cards/iq-card";
import { xray } from "../../config/pluginInit";

export default {
  name: "EventInfo",
  components: { IqCard },
  props: {
    typeSchedule: { default: "PROFESSIONAL" },
    event: {
      default: {},
    },
  },
  mounted() {
    xray.index();
  },
  computed: {},
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>